import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { putVersionApiCrud, type PutVersionRequest } from "@/generated/fastapi";

export async function putVersion(
  accessToken: string | null | undefined,
  request: PutVersionRequest,
) {
  const response = await putVersionApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to update version (${response.status})`);
  }

  return response.data;
}
